import React from "react";
import { Pagination } from "@mui/material";

export const TablePaginated = ({
  count,
  page,
  onChange,
  hasPreviousPage,
  hasNextPage,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        showFirstButton={hasPreviousPage}
        showLastButton={hasNextPage}
        siblingCount={0}
        boundaryCount={1}
      />
    </div>
  );
};
